var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4043 21.8477C21.0615 21.8477 20.1055 20.8916 20.1055 19.5381V2.91992C20.1055 1.56641 21.0615 0.610352 22.4043 0.610352C23.7686 0.610352 24.7139 1.56641 24.7139 2.91992V19.5381C24.7139 20.8916 23.7686 21.8477 22.4043 21.8477ZM8.61133 16.498V6.05664C11.4365 5.74512 15.54 4.75684 18.5908 3.25293C18.5801 3.39258 18.5801 3.51074 18.5801 3.65039V18.9043C18.5801 19.0332 18.5801 19.1621 18.5908 19.291C15.5186 17.7764 11.6943 16.8418 8.61133 16.498ZM4.88379 16.4873C1.89746 16.4873 0.275391 14.9189 0.275391 12.0293V10.5039C0.275391 7.625 1.89746 6.05664 4.88379 6.05664H7.06445V16.4873H4.88379ZM9.24512 23.8779C7.94531 23.8779 7.26855 23.1797 6.69922 21.9658L4.80859 18.002C5.12012 18.002 5.43164 18.0234 5.61426 18.0234C8.36426 18.0879 9.71777 18.2061 10.6846 18.3887L11.2969 21.1709C11.6729 22.8574 10.6416 23.8779 9.24512 23.8779Z",
    fill: "#E5E5EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.a2d8890eedc348b4649d9438c3bb729c.svg";
export { ForwardRef as ReactComponent };